<script>
import {UContextMenu} from 'uloc-vue'
import ListMenu from './list-menu-leilao'

export default {
  name: 'ContextMenuLeilaoItem',
  props: ['leilao'],
  data () {
    return {
      atualizando: false
    }
  },
  computed: {},
  methods: {
  },
  components: {ListMenu, UContextMenu}
}
</script>

<template>
  <u-context-menu ref="context" class="erp-context-menu">
    <list-menu @abrir="$emit('abrir')" @edit="$emit('edit')" />
  </u-context-menu>
</template>
